import { Injectable } from "@angular/core";
import {
	BalanceLimitExceededRealTimeMessagePayload,
	DepositLimitReachedRealTimeMessagePayload,
} from "@obg/common.realtime-notifications";
import { CurrencyService } from "@obg/ngx.global";

import { KsaLimitAlertType, KsaLimitsAlertContainerInputData, KsaLimitsAlertContent } from "./ksa-limits-alert.model";

@Injectable({
	providedIn: "root",
})
export class KsaLimitsAlertService {
	constructor(private currencyService: CurrencyService) {}

	getKsaLimitAlertContent(data: KsaLimitsAlertContainerInputData): KsaLimitsAlertContent | undefined {
		if (data.ksaLimitAlertType === KsaLimitAlertType.DepositLimit) {
			return this.getDepositLimitReachedContent(data.payload as DepositLimitReachedRealTimeMessagePayload);
		}

		if (data.ksaLimitAlertType === KsaLimitAlertType.BalanceLimit) {
			return this.getBalanceLimitExceededContent(data.payload as BalanceLimitExceededRealTimeMessagePayload);
		}

		if (data.ksaLimitAlertType === KsaLimitAlertType.SessionLimit) {
			return this.getSessionLimitReachedContent();
		}

		return undefined;
	}

	private getDepositLimitReachedContent(payload: DepositLimitReachedRealTimeMessagePayload): KsaLimitsAlertContent {
		return {
			title: "limits-alert.deposit-limit-reached.title",
			icon: "ico-deposit",
			message: "limits-alert.deposit-limit-reached.message",
			amountTitle: "limits-alert.deposit-limit-reached.amount-title",
			amountValue: this.currencyService.format(payload.Limit) || undefined,
			limitType: `deposit-limit.limit.option.${payload.LimitType.toLowerCase()}`,
			footer: "limits-alert.deposit-limit-reached.responsible-gaming-info",
		};
	}

	private getBalanceLimitExceededContent(payload: BalanceLimitExceededRealTimeMessagePayload): KsaLimitsAlertContent {
		return {
			title: "limits-alert.balance-limit-exceeded.title",
			icon: "ico-balance-bank",
			message: "limits-alert.balance-limit-exceeded.message",
			amountTitle: "limits-alert.balance-limit-exceeded.amount-title",
			amountValue: this.currencyService.format(payload.Amount) || undefined,
			footer: "limits-alert.balance-limit-exceeded.responsible-gaming-info",
		};
	}

	private getSessionLimitReachedContent(): KsaLimitsAlertContent {
		return {
			title: "limits-alert.session-limit-reached.title",
			icon: "ico-balance-limit-shield",
			message: "limits-alert.session-limit-reached.message",
			footer: "limits-alert.session-limit-reached.responsible-gaming-info",
		};
	}
}
